import { MessageCircle } from "lucide-react";
import { scrollToSection } from "@/lib/scroll";
import { WHATSAPP_URL, PHONE_DISPLAY, PHONE_TEL, ADDRESS_LINE } from "@/data/menu";

export const Footer = () => (
  <footer className="border-t border-[#D4AF37]/20 bg-[#050505] py-14">
    <div className="mx-auto max-w-6xl px-5 md:px-8">
      <div className="grid gap-10 md:grid-cols-3">
        <div>
          <p className="font-display text-xl tracking-[0.35em] text-[#D4AF37]">BAIANEIRA</p>
          <p className="mt-1 text-[9px] tracking-[0.5em] text-[#A3A3A3]">SUSHI FUSION</p>
          <p className="mt-5 text-xs leading-relaxed text-[#A3A3A3]">
            {ADDRESS_LINE}
            <br />
            Zona Cinecittà · Metro Subaugusta
          </p>
          <a
            data-testid="footer-phone-link"
            href={PHONE_TEL}
            className="mt-3 inline-block font-display text-lg text-[#D4AF37] transition-colors hover:text-[#F3E5AB]"
          >
            {PHONE_DISPLAY}
          </a>
          <a
            data-testid="footer-whatsapp-link"
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-3 flex w-fit items-center gap-2 bg-[#25D366] px-4 py-2.5 text-[9px] font-bold tracking-[0.2em] text-[#05220f] transition-transform active:scale-[0.97]"
          >
            <MessageCircle size={13} /> WHATSAPP
          </a>
        </div>

        <div className="text-xs leading-loose">
          <p className="mb-3 text-[10px] font-semibold tracking-[0.3em] text-[#D4AF37]">
            LINK UTILI
          </p>
          <a
            data-testid="footer-privacy-link"
            href="/privacy"
            className="block text-[#A3A3A3] transition-colors hover:text-[#D4AF37]"
          >
            Privacy Policy
          </a>
          <a
            data-testid="footer-cookie-link"
            href="/cookie-policy"
            className="block text-[#A3A3A3] transition-colors hover:text-[#D4AF37]"
          >
            Cookie Policy
          </a>
          <a
            data-testid="footer-conditions-link"
            href="#condizioni"
            onClick={(e) => {
              e.preventDefault();
              scrollToSection("#condizioni");
            }}
            className="block text-[#A3A3A3] transition-colors hover:text-[#D4AF37]"
          >
            Condizioni di utilizzo
          </a>
          <a
            data-testid="footer-admin-link"
            href="/admin"
            className="block text-[#A3A3A3]/60 transition-colors hover:text-[#D4AF37]"
          >
            Area riservata
          </a>
        </div>

        <div className="text-xs leading-loose">
          <p className="mb-3 text-[10px] font-semibold tracking-[0.3em] text-[#D4AF37]">
            SITO UFFICIALE
          </p>
          <a
            data-testid="footer-website-link"
            href="https://www.baianeira.it"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#A3A3A3] transition-colors hover:text-[#D4AF37]"
          >
            www.baianeira.it
          </a>
          <p className="mt-5 text-[10px] leading-relaxed text-[#777]">
            Bevande, dolci, coperto, aperisushi e menù degustazione esclusi dalla promozione.
          </p>
        </div>
      </div>

      <p className="mt-12 border-t border-white/5 pt-6 text-center text-[10px] tracking-[0.2em] text-[#555]">
        © {new Date().getFullYear()} BAIANEIRA SUSHI FUSION
      </p>
    </div>
  </footer>
);

export default Footer;
